import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import PtNodata from '../PtNodata';
import FileWrapperMultiViewModify from './FileWrapperMultiViewModify.vue';
import FileWrapperMultiViewArgument from './FileWrapperMultiViewArgument.vue';
import useFileWrapperMultiView from '../../composables/use-file-wrapper-multi-view';
import { Popover } from 'element-ui';
import _ from 'lodash';
import { Icon as PtIcon } from 'patsnap-biz';
import '@patsnap-ui/icon/assets/solid/AssigneeCompany.svg';
import '@patsnap-ui/icon/assets/solid/AddLarge.svg';
import '@patsnap-ui/icon/assets/solid/CloseBig.svg';


export default /*#__PURE__*/_defineComponent({
  __name: 'FileWrapperApplicant',
  setup(__props) {

const { currentRoundDetail } = useFileWrapperMultiView();

const responseData = computed(() => {
    return _.get(currentRoundDetail.value, 'response', []);
});

const modifyFileData = computed(() => {
    // 拼接list
    const list = [];
    _.forEach(responseData.value, responseItem => {
        const data = _.pick(responseItem, ['claims', 'desc']);
        for (const key in data) {
            const items = data[key];
            _.forEach(items, item => {
                if (key === 'desc' && !item.pdf) {
                    return;
                }
                list.push({
                    ...item,
                    type: key,
                });
            });
        }
    });
    return list;
});

const hasModify = computed(() => {
    return modifyFileData.value.length > 0;
});

const argumentsData = computed(() => {
    let list = [];
    _.forEach(responseData.value, responseItem => {
        const data = _.get(responseItem, 'arguments', []);
        list = _.concat(list, data);
    });
    return list;
});

const hasArgument = computed(() => {
    return argumentsData.value.length > 0;
});

const nodata = computed(() => {
    return !hasModify.value && !hasArgument.value;
});


// 刚进来的初始逻辑
// 如果modify第一条没数据，则展示argument
const firstModify = _.head(modifyFileData.value);
const hasFirstModifyValue = !!(_.get(firstModify, 'pdf') || _.get(firstModify, 'text'));
const showModify = ref(hasModify.value && hasFirstModifyValue);
const showArgument = ref(hasArgument.value && (!hasModify.value || !hasFirstModifyValue));

const showDoubleColView = computed(() => {
    return showArgument.value === true && showModify.value === true;
});

const changeView = (type, view) => {
    window.rvTrack('Change Patent File Wrapper Multi View Rejection');
    if (type === 'add') {
        if (view === 'argument' && hasArgument.value) showArgument.value = true;
        if (view === 'modify' && hasModify.value) showModify.value = true;
    } else if (type === 'del') {
        if (view === 'argument') showArgument.value = false;
        if (view === 'modify') showModify.value = false;
    }
};

const applicantWidth = computed(() => {
    if (nodata.value) {
        return 'calc(100% / 3)';
    }
    if (showDoubleColView.value) {
        return 'calc(100% / 3 * 2)';
    }
    return '50%';
});

// 用作两列初始化联动
const currentMrdtInSingleView = ref(null);

const changeCurrentMrdt = (mrdt) => {
    if (!showDoubleColView.value) {
        currentMrdtInSingleView.value = mrdt;
    }
};


return { __sfc: true,currentRoundDetail, responseData, modifyFileData, hasModify, argumentsData, hasArgument, nodata, firstModify, hasFirstModifyValue, showModify, showArgument, showDoubleColView, changeView, applicantWidth, currentMrdtInSingleView, changeCurrentMrdt, PtNodata, FileWrapperMultiViewModify, FileWrapperMultiViewArgument, Popover, PtIcon }
}

})